document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Galerie produit ---------- */
  var thumbs = document.querySelectorAll('[data-thumb]');
  var mainImg = document.getElementById('gallery-main-img');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    });
  });

  /* ---------- Sélecteur de quantité (page produit) ---------- */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
    });
  });
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-qty-input]');
      var val = Math.max(1, parseInt(input.value || '1', 10) + 1);
      input.value = val;
    });
  });

  /* ---------- Quantités page panier (met à jour /cart/change.js) ---------- */
  function changeLineQty(index, newQty) {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/change.js'
      : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: index, quantity: newQty })
    }).then(function () { window.location.reload(); });
  }
  document.querySelectorAll('[data-line-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.getAttribute('data-line-qty-minus');
      var input = document.querySelector('[data-line-qty-input="' + idx + '"]');
      var newVal = Math.max(0, parseInt(input.value, 10) - 1);
      changeLineQty(idx, newVal);
    });
  });
  document.querySelectorAll('[data-line-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = btn.getAttribute('data-line-qty-plus');
      var input = document.querySelector('[data-line-qty-input="' + idx + '"]');
      var newVal = parseInt(input.value, 10) + 1;
      changeLineQty(idx, newVal);
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Panier en tiroir (drawer) ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    refreshCartDrawer();
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
  }
  cartToggleBtns.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeDrawer); });

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var itemsWrap = document.querySelector('[data-cart-items]');
        var countEls = document.querySelectorAll('[data-cart-count]');
        var subtotalEl = document.querySelector('[data-cart-subtotal]');

        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

        if (!itemsWrap) return;

        if (cart.item_count === 0) {
          itemsWrap.innerHTML = '<p class="cart-drawer__empty">Votre panier est vide.</p>';
          return;
        }

        var html = '';
        cart.items.forEach(function (item) {
          html += '<div class="cart-drawer__item">';
          html += '<img src="' + item.image + '" alt="' + item.title + '">';
          html += '<div>';
          html += '<p class="cart-drawer__item-title">' + item.product_title + '</p>';
          html += '<p class="cart-drawer__item-meta">Qté : ' + item.quantity + ' · ' + money(item.final_line_price) + '</p>';
          html += '</div></div>';
        });
        itemsWrap.innerHTML = html;
      });
  }

  /* ---------- Ajout au panier (AJAX, sans recharger la page) ---------- */
  var productForms = document.querySelectorAll('form[action^="/cart/add"], form[action*="/cart/add"]');
  productForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.hasAttribute('data-buy-now')) return; // laissé pour le bouton "Acheter maintenant"

      e.preventDefault();
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          showNotification('Added to cart ✓');
          openDrawer();
        })
        .catch(function () {
          showNotification("Something went wrong, please try again.");
        });
    });
  });

  /* ---------- Bouton "Acheter maintenant" : ajoute puis redirige direct au checkout ---------- */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      }).then(function () {
        window.location.href = '/checkout';
      });
    });
  });

  function showNotification(message) {
    var toast = document.getElementById('cart-notification');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    setTimeout(function () { toast.classList.remove('is-visible'); }, 2200);
  }

  /* ---------- Accordéon FAQ ---------- */
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('[data-faq-answer]');
      var isOpen = item.classList.contains('is-open');

      document.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('[data-faq-answer]').style.maxHeight = null;
          openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

});
